import { createUseTranslation } from '@shared/hooks/create-use-translation';

import type { CommonTranslationKeys } from '../types';

export const useCommonTranslation =
  createUseTranslation<CommonTranslationKeys>('COMMON');
